import { createReducer } from "redux-act";
import createAction from "./utils/createMetaAction";
import { noop } from "lodash-es";
export const toggleReadOnlyMode = createAction("TOGGLE_READ_ONLY_MODE", noop);
export const updateReadOnlyMode = createAction("UPDATE_READ_ONLY_MODE");
export default createReducer(
  {
    [updateReadOnlyMode]: (state, payload) => {
      return payload;
    },
    [toggleReadOnlyMode]: (state) => {
      return !state;
    }
  },
  false
);
